import React from 'react';
import RulesHeader from 'Components/RulesHeader';

type DeployButtonSelectorProps = {
    rulesType: RulesType;
    hasDeployAccess: boolean;
    shouldShowScheduledDeployment?: boolean;
};

const DeployButtonSelector = ({
    rulesType,
    hasDeployAccess,
    shouldShowScheduledDeployment
}: DeployButtonSelectorProps) => {
    if (!hasDeployAccess) {
        return null;
    }

    if (shouldShowScheduledDeployment) {
        return <RulesHeader.ScheduledDeploymentButton rulesType={rulesType} />;
    }

    return <RulesHeader.DeployButton rulesType={rulesType} />;
};

export default DeployButtonSelector;
